<template>
  <div class="super-vision">
    <div class="calc-templete">
      <h6>监理服务费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit" labelWidth="195px">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>监理服务费</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
             
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">
          <t-input v-model="formData.projectName" placeholder="请输入工程名称" style="width: 320px;"></t-input>
        </t-form-item>

        <t-form-item label="工程造价" name="money">
          <t-input-number v-model="formData.money" placeholder="请输入工程造价" style="width: 320px;" suffix="万元（中标价）" type="number" :min="0" theme="normal"></t-input-number>
        </t-form-item>
        <t-form-item name="domainCoefficient" label="专业调整" class="form-item-left">
          <t-input v-model="formData.domainCoefficient" placeholder="请选择专业调整系数" style="width: 320px;"></t-input>
         
          <t-button theme="default" variant="outline" class="coefficient" @click="openVisible1">系数说明
            <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
          </t-button>
        </t-form-item>
        <t-form-item name="complexityCoefficient" label="复杂调整" class="form-item-left">
          <t-input v-model="formData.complexityCoefficient" placeholder="请选择工程复杂程度调整系数" style="width: 320px;"></t-input>
          <t-button theme="default" variant="outline" class="coefficient" @click="openVisible2">系数说明
            <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
          </t-button>
        </t-form-item>
        <t-form-item name="elevationCoefficient" label="高程调整" class="form-item-left">
          <t-input v-model="formData.elevationCoefficient" placeholder="请选择高程调整系数" style="width: 320px;"></t-input>
          <t-button theme="default" variant="outline" class="coefficient" @click="openVisible3">系数说明
            <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
          </t-button>
        </t-form-item>
        <t-form-item label="让利利率" name="discountRate">
               <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :min="0" :max="100" theme="normal"/>
              <!-- <t-input v-model="formData.discountRateMoney" placeholder="" disabled suffix="元"
            style="width: 217px;margin-left: 16px;" ></t-input> -->
            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">提交结果</t-button>
            </t-col>
            <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item name="subtotal" class="form-item-left">
          <span slot="label">
            监理费基价
          </span>
          <t-input v-model="formData.subtotal" placeholder="" disabled style="width: 320px;"
            suffix="元"></t-input>
        </t-form-item>
        
        <t-form-item label="监理服务费" name="standardPrice">
          <t-input v-model="formData.standardPrice" placeholder="" disabled style="width: 320px;" suffix="元"
            ></t-input>
        </t-form-item>
        <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>
       
        <t-form-item label="折后监理费" name="result">
          <t-input v-model="formData.result" placeholder="" disabled style="width: 320px;" suffix="元"
            @change="resultChange"></t-input>
        </t-form-item>
        <t-form-item label="金额大写" name="resultChinese">
          <t-input v-model="resultChinese" placeholder="" disabled style="width: 320px;"></t-input>
        </t-form-item>
        <!-- <t-button class="download" @click="downLoad" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button> -->
              <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
            </t-col>
          </t-row>
        
      
      </t-form>
    </div>

    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>设计服务费计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
             <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;" >{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>

    <t-dialog placement="center" :visible="visible1" :footer="false" :onConfirm="close1" :onClose="close1"
      class="dialog1">
      <span slot="header">
        专业调整系数
        <div class="closeButton" @click="close1"></div>
      </span>

      <p>矿山采选工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="黑色、有色、黄金、化学、非金属及其他矿采选工程-0.9">黑色、有色、黄金、化学、非金属及其他矿采选工程 <span>0.9</span></t-radio>
          <t-radio value="选煤及其他煤炭工程-1.0">选煤及其他煤炭工程 <span>1.0</span></t-radio>
          <t-radio value="矿井工程，铀矿采选工程-1.1">矿井工程，铀矿采选工程 <span>1.1</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>加工冶炼工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="冶炼工程-0.9">冶炼工程 <span>0.9</span></t-radio>
          <t-radio value="船舶水工工程-1.0">船舶水工工程 <span>1.0</span></t-radio>
          <t-radio value="各类加工-1.0">各类加工 <span>1.0</span></t-radio>
          <t-radio value="核加工工程-1.2">核加工工程 <span>1.2</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>石油化工工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="石油工程-0.9">石油工程 <span>0.9</span></t-radio>
          <t-radio value="化工、石化、化纤、医药工程 -1.0">化工、石化、化纤、医药工程 <span>1.0</span></t-radio>
          <t-radio value="核化工工程-1.2">核化工工程 <span>1.2</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>水利电力工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="风力发电、其他水利工程-0.9">风力发电、其他水利工程 <span>0.9</span></t-radio>
          <t-radio value="火电、变送电工程-1.0">火电、变送电工程 <span>1.0</span></t-radio>
          <t-radio value="核能、水电、水库工程-1.2">核能、水电、水库工程 <span>1.2</span></t-radio>
        </t-radio-group>
      </t-space>

      <p>交通运输工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="机场道路、助航灯光-0.9">机场道路、助航灯光 <span>0.9</span></t-radio>
          <t-radio value="铁路、公路、城市道路、轻轨及机场空管工程-1.0">铁路、公路、城市道路、轻轨及机场空管工程 <span>1.0</span></t-radio>
          <t-radio value="水运、地铁、桥梁、隧道、索道工程-1.1">水运、地铁、桥梁、隧道、索道工程 <span>1.1</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>建筑市政工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="园林绿化工程-0.8">园林绿化工程 <span>0.8</span></t-radio>
          <t-radio value="建筑、人防、市政公用工程-1.0">建筑、人防、市政公用工程 <span>1.0</span></t-radio>
          <t-radio value="邮政、电信、广播电视工程-1.0">邮政、电信、广播电视工程 <span>1.0</span></t-radio>
        </t-radio-group>
      </t-space>
      <p>农业林业工程</p>
      <t-space>
        <t-radio-group v-model="value1" @change="onChange1">
          <t-radio value="农业工程-0.9">农业工程 <span>0.9</span></t-radio>
          <t-radio value="林业工程-0.9">林业工程 <span>0.9</span></t-radio>
          <!-- <t-radio value="水运、地铁、桥梁、隧道、索道工程-1.1">水运、地铁、桥梁、隧道、索道工程 <span>1.1</span></t-radio> -->
        </t-radio-group>
      </t-space>

    </t-dialog>

    <t-dialog placement="center" :visible="visible2" :footer="false" :onConfirm="close2" :onClose="close2"
      class="dialog2">
      <span slot="header">
        工程复杂程度调整系数
        <div class="closeButton" @click="close2"></div>
      </span>
      <t-form style="    padding: 0 25%;
    margin-top: 20px;">
      <t-form-item label="工程类型" name="complexityCoefficient">
      <t-cascader class="custom-cascader-1" :options="complexityCoefficientList"
        clearable key="id" :keys="{ value: 'id', label: 'name', children: 'children' }" @change="changecomplexityCoefficient" ></t-cascader></t-form-item></t-form>
      <p>复杂程序</p>
      <t-space>
        <t-radio-group v-model="value2" @change="onChange2">
          <t-radio :value="item.name" v-for="item in this.complexityRadioGroupList" :key="item.id">
            {{ item.name.split('-')[0] }} <span>{{ item.number.toFixed(2) }}</span>
            
          </t-radio>
          <!-- <t-radio value="较复杂（Ⅱ级）-1.0">较复杂（Ⅱ级） <span>1.0</span></t-radio>

          <t-radio value="复杂（Ⅲ级）-1.15">复杂（Ⅲ级） <span>1.15</span></t-radio> -->
        </t-radio-group>
      </t-space>
      <template>
        <div v-show="this.complexityRemark" v-html="this.complexityRemark" style="text-align: left;
    padding: 20px;padding-bottom: 0px;"></div>
        <t-table class="complexity-table"
  bordered
        row-key="id"
        :data="this.complexityRadioGroupList"
        :columns="complexitycolumns"
      >
      <template #name="{row}">
      <!-- 在此处通过 v-html 显示 HTML 内容 -->
      <div >{{ row.name.split('-')[0] }}</div>
    </template>
      <template #features="{row}">
      <!-- 在此处通过 v-html 显示 HTML 内容 -->
      <div v-html="row.features"></div>
    </template>
    </t-table>
    </template>
   

    </t-dialog>

    <t-dialog placement="center" :visible="visible3" :footer="false" :onConfirm="close3" :onClose="close3"
      class="dialog3">
      <span slot="header">
        高程调整系数
        <div class="closeButton" @click="close3"></div>
      </span>
      <p>海拔高程</p>

      <t-radio-group v-model="value3" @change="onChange3">
        <t-space style="margin: 0 auto;">
          <t-radio value="2001m以下的=1.0">2001m以下的 <span>1.0</span></t-radio>
          <t-radio value="2001-3000m以下的=1.1">2001-3000m以下的 <span>1.1</span></t-radio>
        </t-space>
        <t-space style="margin: 0 auto;">
          <t-radio value="3001-3500m以下的=1.2">3001-3500m以下的 <span>1.2</span></t-radio>
          <t-radio value="3501-4000m以下的=1.3">3501-4000m以下的 <span>1.3</span></t-radio>
          <t-radio value="4001m以上的，协商确定">4001m以上的，协商确定</t-radio>
        </t-space>
      </t-radio-group>


    </t-dialog>
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import {  getComplexity,getServer } from '@/api/data'
import { listRate } from "@/api/rate";
import { listFile } from "@/api/file";

export default {
  name: 'superVision',
  components: {

  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl:null,
      openFileUrl: null,
      downLoading: false,
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        domainCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        complexityCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        elevationCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        otherDesign: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }]
      },
      helpOpen: false,
      downData: {},
      value1: '',
      visible1: false,
      value2: '',
      visible2: false,
      value3: '',
      visible3: false,
      discountRate: null,
      formData: {
        projectName: '',
        ificationId:this.$route.query.ification,
        money: null,
        subtotal: null, //施工监理服务收费基价
        domainCoefficientName:null,//专业调整系数名称
        domainCoefficient: null,//专业调整系数
        complexityCoefficientName:null,//工程复杂程度调整系数名称
        complexityCoefficient: null,//工程复杂程度调整系数
        elevationCoefficientName:null,
        elevationCoefficient: null,//高程调整系数
        standardPrice: null,//施工监理服务收费基准价
        discountRate: 0,
        discountRateMoney: null,
        result: null,
        remark: 1
      },
      resultChinese: '',
      fileList: [],
      complexityCoefficientList:[],
      complexityList:[],
      complexityRadioGroupList:[],
      complexityRemark:null,
      data: [{
       
      }],
      columns: [
      {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '收费区间值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '收费基价（万元）',
          colKey: 'rate',
          width: 100,
        }

      ],
      complexitycolumns:[
      {
          title: '等级',
          colKey: 'name',
          width: 50,
        },
        {
          title: '工程特征',
          colKey: 'features',
          width: 180,
        }
        
      ],
      calculateRange:null,//计算范围
      calculationFormula:null // 计算公式

    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        this.fileList = response.rows[0];
  
      });

      getComplexity({ificationId : '1'}).then(res => {
      this.complexityList = res.data
      res.data.forEach(item => {
        item.id = String(item.id)
      })
      this.complexityCoefficientList = this.handleTreeSecond(res.data)

      // console.log(this.handleTree(res.data))
    })


      listRate({ ificationId: this.$route.query.ification}).then(res => {
      let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999){
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
        
      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if(res.data.scope){
          if (res.data.scope.indexOf("\\n")!=-1){
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          }else{
            this.calculateRange = res.data.scope
          }
          
        }else{
          this.calculateRange = '暂无数据'
        }
        if(res.data.particulars){
          if (res.data.particulars.indexOf("\\n")!=-1){
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          }else{
            this.calculationFormula = res.data.particulars
          }
        }else{
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    handleClear() {
      this.helpOpen = true
    },




    submit() {
      // console.log(111)
      this.formData.discountRate = Number(this.discountRate) / 100
      getServer(this.formData).then(res => {
        this.downData = res.data
        this.formData.money = res.data.money.toString()
        this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        this.formData.standardPrice = res.data.standardPrice.toFixed(2).toString()

        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        this.jsgc = res.data.jsgc
      })

    },
    downLoad() {
      this.downLoading = true
      this.download('/project/fee/excle', { id: this.downData.id,classId:22 }
        , `监理服务费计算.xlsx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:'工程造价' + this.formData.money + '（万元）' + `;专业调整${this.formData.domainCoefficient};复杂调整:${this.formData.complexityCoefficient};高程调整:${this.formData.elevationCoefficient};让利利率：${this.discountRate}%。`,
        yjwj:this.fileList && this.fileList.fileName || '无文件',
        // gctz:this.formData.domainCoefficientName,
        fzcdtzxs:this.formData.domainCoefficient,
        zytixs:this.formData.complexityCoefficient,
        gctzxs:this.formData.elevationCoefficient,
        jsgc:this.jsgc,
        fulx:'监理服务费',
        zhj:this.formData.result + '元',
      }
      this.download('/project/fee/jlfword', { id: this.downData.id, classId: 22,...wordParam }
        , `监理服务费计算.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    openVisible1() {
      this.visible1 = true
    },
    close1() {
      this.visible1 = false;
    },
    onChange1(checkedValues) {
      // console.log('checkedValues:', this.value1, checkedValues.split('-').slice(-1));
      this.formData.domainCoefficientName = checkedValues.split('-')[0].toString()
      this.formData.domainCoefficient = checkedValues.split('-').slice(-1).toString()
    },
    openVisible2() {
      this.visible2 = true
    },
    close2() {
      this.visible2 = false;
    },
    onChange2(checkedValues) {
      // console.log('checkedValues:', this.value2, checkedValues.split('-').slice(-1));
      this.formData.complexityCoefficientName = checkedValues.split('-')[0].toString()
      this.formData.complexityCoefficient = checkedValues.split('-').slice(-1).toString()
    },
    openVisible3() {
      this.visible3 = true
    },
    close3() {
      this.visible3 = false;
    },
    onChange3(checkedValues) {
      console.log('checkedValues:', this.value3, checkedValues.split('=').slice(-1));
      this.formData.elevationCoefficientName = checkedValues.split('=')[0].toString()
      if (checkedValues.split('=').slice(-1) == '4001m以上的，协商确定') {
        this.formData.elevationCoefficient = null
      } else {
        this.formData.elevationCoefficient = checkedValues.split('=').slice(-1).toString()
      }

    },
    changecomplexityCoefficient(val, context) {
      this.complexityRadioGroupList=[]
      // console.log( val, context);
      // console.log('path: ', context.node.getPath());
      // this.formData.complexityCoefficientName = context.node.data.name
      this.complexityRemark = context.node.data.remark
      // console.log(this.complexityRemark)
      // this.formData.complexityCoefficient = context.node.data.name
      this.complexityList.forEach((item) => {
        if (item.parentId == val){
          this.complexityRadioGroupList.push(item)
        }
      })
      // console.log(this.complexityRadioGroupList)
      
    },
    fileOpenDialog(url) {
      this.downFileUrl =  url
      let fileUrl = '/pdfjs/web/viewer.html?file=' + process.env.VUE_APP_BASE_API + url
      // window.open(fileUrl,'_blank')
      this.openFileUrl = fileUrl
      this.visible = true
    }
  },
}
</script>

<style lang="less">
.super-vision {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;



  .dialog1 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      min-width: 902px !important;
      // height: 720px !important;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 8px !important;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }

        }

        .t-space {
          margin-bottom: 20px;
        }
      }
    }
  }

  .dialog2 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 902px;
      // height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        background: url('@/assets/dialog-background.png');
       
        padding: 0;

        .t-form__label{
          height: 32px;
        line-height: 32px;
        font-family: "Regular";
        }
        .custom-cascader-1{
          width: 300px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }
        .complexity-table{
          padding: 20px;
          background: url('@/assets/dialog-background.png');
        }
      }
    }
  }

  .dialog3 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 902px;
      height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');
        height: 150px;

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }
      }
    }
  }



}

</style>
